// Number / currency / time formatters used across the UI.

const COMPACT = new Intl.NumberFormat("en", {
  notation: "compact",
  maximumFractionDigits: 1,
});

export function compactNumber(n) {
  if (n == null || isNaN(n)) return "0";
  return COMPACT.format(Number(n));
}

export function plainNumber(n) {
  if (n == null || isNaN(n)) return "0";
  return Number(n).toLocaleString("en");
}

// Pop is always quoted "per 1k" (per the WhatsApp market convention). The
// seller stores `rates.{seg}.base` as the price per 1,000 popularity.
export function formatRatePer1k(amount, currency = "INR") {
  if (amount == null || isNaN(amount)) return "—";
  const sym = currencySymbol(currency);
  return `${sym}${Number(amount).toFixed(amount >= 100 ? 0 : 2)}/k`;
}

// Standalone item prices (Lumen, Helicopter) are flat — quoted as full
// amount per item, not per 1k.
export function formatFlatPrice(amount, currency = "INR") {
  if (amount == null || isNaN(amount)) return "—";
  const sym = currencySymbol(currency);
  return `${sym}${Number(amount).toFixed(0)}`;
}

const CURRENCY_SYMBOL = {
  INR: "₹", USD: "$", EUR: "€", GBP: "£", AED: "AED ",
  IDR: "Rp ", PHP: "₱", BRL: "R$", PKR: "₨", BDT: "৳",
  CNY: "¥", JPY: "¥", THB: "฿", VND: "₫",
};
export function currencySymbol(code) {
  return CURRENCY_SYMBOL[code] || `${code} `;
}

export function relativeTime(date) {
  if (!date) return "—";
  const d = date.toDate ? date.toDate() : new Date(date);
  const diff = Date.now() - d.getTime();
  const s = Math.floor(diff / 1000);
  if (s < 60)      return `${s}s ago`;
  const m = Math.floor(s / 60);
  if (m < 60)      return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24)      return `${h}h ago`;
  const dy = Math.floor(h / 24);
  if (dy < 30)     return `${dy}d ago`;
  const mo = Math.floor(dy / 30);
  if (mo < 12)     return `${mo}mo ago`;
  const y = Math.floor(mo / 12);
  return `${y}y ago`;
}

// Is the seller currently online? Threshold = 15 min since `lastActiveAt`.
export function isOnline(lastActiveAt) {
  if (!lastActiveAt) return false;
  const d = lastActiveAt.toDate ? lastActiveAt.toDate() : new Date(lastActiveAt);
  return Date.now() - d.getTime() < 15 * 60 * 1000;
}

const FLAG_OVERRIDES = { Global: "🌐" };
export function regionFlag(region, countryCode) {
  if (FLAG_OVERRIDES[region]) return FLAG_OVERRIDES[region];
  // Emoji flag from ISO-2: each letter maps to its regional indicator.
  if (countryCode && /^[A-Za-z]{2}$/.test(countryCode)) {
    const cc = countryCode.toUpperCase();
    return String.fromCodePoint(0x1F1E6 + (cc.charCodeAt(0) - 65),
                                0x1F1E6 + (cc.charCodeAt(1) - 65));
  }
  return "🌐";
}
